import type { CoreStoreType } from '../../../store/CoreStore';
import type { IGameCommunicationProcessor, TableCloseMessage } from '../types';

export class GameCommunicationTableProcessor implements IGameCommunicationProcessor {
  messageName = 'table';

  process(message: TableCloseMessage, store: CoreStoreType): void {
    //
  }
}
